// 9fbef606107a605d69c0edbcd8029e5d
import PropTypes from 'prop-types';

export default {
  className: PropTypes.string,
  outfitProduct: PropTypes.objectOf(PropTypes.oneOfType([PropTypes.string])),
  selectedProductId: PropTypes.string,
  productIndexText: PropTypes.string,
  isCanada: PropTypes.bool,
  isPlcc: PropTypes.bool,
  isInternationalShipping: PropTypes.bool.isRequired,
  currencySymbol: PropTypes.string,
  currencyAttributes: PropTypes.shape({}).isRequired,
  handleAddToBag: PropTypes.func.isRequired,
  addToBagError: PropTypes.bool,
  addToFavorites: PropTypes.func.isRequired,
  isLoggedIn: PropTypes.bool,
  isBundleProduct: PropTypes.bool,
  isKeepAliveEnabled: PropTypes.bool,
  AddToFavoriteErrorMsg: PropTypes.string,
  removeAddToFavoritesErrorMsg: PropTypes.func,
  pageName: PropTypes.string,
  isOnModelAbTestBundlePdp: PropTypes.bool,
  isOnModelAbTestOutfitPdp: PropTypes.bool,
  showAddedToBagCta: PropTypes.string,
  isDynamicBadgeEnabled: PropTypes.shape({}),
  getAllNewMultiPack: PropTypes.shape({}),
};
